// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { css } from "styled-components";

export const blogTileWrapperStyles = () => css`
    position: relative;
    display: flex;
    height: 100%;
    flex-direction: column;
    flex-grow: 1;
`;

export const blogTileImageStyles = (aspectRatio = "4/3") => css`
    transition: ${transitionHoverStyles("scale")};
    max-width: 100%;
    width: 100%;
    height: auto;
    object-fit: cover;
    aspect-ratio: ${aspectRatio};
`;

export const blogTileReadMoreStyles = (color: string) => css`
    position: relative;
    display: block;
    width: fit-content;
    text-transform: uppercase;
    color: ${getColor(color)};

    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smaller};
        font-weight: ${theme.design.typography.weight.bold};
        line-height: ${theme.design.typography.lineHeight.semi};
    `};
`;
